import Vue from 'vue';
import Router from 'vue-router';
import MainView from './views/Main.vue';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import PlayingView from './views/Playing.vue';
import MelosStations from './views/MelosStations.vue';
import MelosContentCollection from './views/MelosContentCollection.vue';
import MelosDevices from './views/MelosDevices.vue';
import TrackDetails from './views/TrackDetails.vue';
import PodcastDetails from './views/PodcastDetails.vue';
import UserDetails from './views/UserDetails.vue';
import DeviceDetails from './views/DeviceDetails.vue';
import StationDetails from './views/StationDetails.vue';
import StationSchedule from './views/StationSchedule.vue';
import StationSlotContent from './views/StationSlotContent.vue';

Vue.use(Router);

export default new Router({
  mode: process.env.VUE_APP_ROUTER_MODE === 'hash' ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'mainView',
      component: MainView,
      children: [
        {
          path: 'home',
          name: 'home',
          component: Home,
          children: [
            {
              path: 'stations',
              name: 'stations',
              component: MelosStations,
            },
            {
              path: 'collection',
              name: 'collection',
              component: MelosContentCollection,
            },
            {
              path: 'devices',
              name: 'devices',
              component: MelosDevices,
            },
          ],
        },
        {
          path: 'playing',
          name: 'playing',
          component: PlayingView,
        },
        {
          path: 'me',
          name: 'userDetails',
          component: UserDetails,
        },
        {
          path: 'tracks/multiple',
          name: 'multiTrackDetails',
          component: TrackDetails,
        },
        {
          path: 'tracks/:trackId',
          name: 'trackDetails',
          component: TrackDetails,
        },
        {
          path: 'podcasts/:podcastId',
          name: 'podcastDetails',
          component: PodcastDetails,
        },
        {
          path: 'devices/:deviceId',
          name: 'deviceDetails',
          component: DeviceDetails,
        },
        {
          path: 'stations/:stationId',
          name: 'stationDetails',
          component: StationDetails,
          children: [
            {
              path: 'schedule',
              name: 'schedule',
              component: StationSchedule,
              children: [
                {
                  path: 'slot/:index',
                  name: 'slotContent',
                  component: StationSlotContent,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: '/login',
      name: 'about',
      component: Login,
    },
  ],
});
